import { render, staticRenderFns } from "./DpChildSurveyWelcomePage.vue?vue&type=template&id=33328040&"
import script from "./DpChildSurveyWelcomePage.vue?vue&type=script&lang=ts&"
export * from "./DpChildSurveyWelcomePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports